module.exports = __webpack_public_path__ + "54577fd6cc872868ee306c1103841cf2.jpg";